import { FOLLOW_UP_PAYLOAD_KEY } from "@/lib/agents/messaging/follow-ups/constants"
import { OFFLINE_MESSAGE_PAYLOAD_KEY } from "@/lib/agents/messaging/channels/shared/offline-message"

/**
 * Set on an inbound row the runtime judged non-actionable (a story mention, a blank
 * sticker, an empty postback). Such a row is stored for operator visibility but is not
 * a customer message: it neither reaches the LLM nor keeps a session alive. Persisted
 * because a placeholder row carries generated, non-blank text — no reader can tell from
 * `content_text` what the runtime decided.
 */
export const NON_ACTIONABLE_PAYLOAD_KEY = 'non_actionable'

/** When the customer removed the message on their side. The text stays: it is what the AI answered. */
export const CUSTOMER_DELETED_PAYLOAD_KEY = "deleted_by_customer_at"

/** Markers a stored message carries on its payload, read the same way in both inboxes and the prompt. */
export function messagePayloadFlags(payload: Record<string, unknown> | null | undefined) {
  return {
    isFollowUp: Boolean(payload?.[FOLLOW_UP_PAYLOAD_KEY]),
    isOfflineMessage: Boolean(payload?.[OFFLINE_MESSAGE_PAYLOAD_KEY]),
    isDeletedByCustomer: Boolean(payload?.[CUSTOMER_DELETED_PAYLOAD_KEY]),
  }
}
